var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2314 11.5991V13.6243H7.61548V11.5991H19.2314ZM14.5059 6.65245V18.99H12.3526V6.65245H14.5059Z",
    fill: "#7ABB5C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.4699,
    cy: 12.4885,
    r: 11.2,
    stroke: "#7ABB5C",
    strokeWidth: 2.24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d3f77c7a14ed08388647af17e140a5e8.svg";
export { ForwardRef as ReactComponent };